var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3546 2.6437C13.7223 1.0125 11.4822 0 8.9944 0 4.0188 0 0 4.0275 0 9s4.0188 9 8.9944 9c4.1988 0 7.6998-2.8687 8.7017-6.75h-2.3415c-.9231 2.6213-3.4221 4.5-6.3602 4.5C5.2683 15.75 2.24 12.7238 2.24 9c0-3.7237 3.0282-6.75 6.7543-6.75 1.8686 0 3.5347.7763 4.7504 2.0025L10.1201 7.875H18V0l-2.6454 2.6437z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.98ea1d24.svg";
export { ForwardRef as ReactComponent };